import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './client';

export const createQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 10_000,
        refetchOnWindowFocus: true,
        // Don't hammer on answers that won't change by retrying.
        retry: (count, err) => !(err instanceof ApiError && err.status >= 400 && err.status < 500) && count < 2,
      },
    },
  });

/** The app's one query cache, shared by the React tree and the router's loaders. */
export const queryClient = createQueryClient();
